import { Component, Input } from "@angular/core";

@Component({
  selector: "page-card-item-description",
  template: "",
  standalone: false
})
export class PageCardItemDescription {
  @Input() description!: string;
}
